import styled, { css } from "styled-components"

import { spacing } from "@izettle/otto"

import { ModalSize } from "../../../enumerations"

import { ModalFooterProps } from "./types"

export const ModalFooterFill = styled.div`
  margin-right: auto;
  margin-top: 0 !important;
`

const ifSmall =
  (yes: string, no: string) =>
  ({ size }: { size?: ModalSize }) =>
    size === ModalSize.Small ? yes : no

const mixinFooterMobile = ({ isMobile }: ModalFooterProps) =>
  isMobile
    ? css`
        padding: ${spacing.small};
        flex-direction: column-reverse;
        align-items: stretch;
        > * + * {
          margin-bottom: ${spacing.medium};
        }
      `
    : css`
        padding: ${spacing.medium};
        padding-bottom: 0;
        flex-direction: row;
        align-items: center;
        > * + * {
          margin-left: ${ifSmall(spacing.xxSmall, spacing.medium)};
        }
      `

export const ModalFooterContainer = styled.div<ModalFooterProps>`
  display: flex;
  justify-content: flex-end;
  min-height: fit-content;
  ${mixinFooterMobile}
`

const mixinFooterSpecializedActionsContainer = ({ isMobile }: ModalFooterProps) =>
  isMobile
    ? css`
        margin: -${ifSmall(spacing.tiny, spacing.xSmall)};
        margin-bottom: calc(
          -${ifSmall(spacing.xSmall, `${spacing.medium} + ${spacing.tiny}`)}
        );
        flex-wrap: wrap-reverse;
        > * {
          flex: 2 1 40%;
          margin: ${ifSmall(spacing.tiny, spacing.xSmall)};
        }
      `
    : css`
        > * + * {
          margin-left: ${ifSmall(spacing.xxSmall, spacing.medium)};
        }
      `

export const ModalFooterSpecializedActionsContainer = styled.div<ModalFooterProps>`
  display: flex;

  ${mixinFooterSpecializedActionsContainer}
`
